export default __webpack_public_path__ + "static/media/Senators.f1e2415a.png";